export const UPDATED = 'UPDATED';
export const PUBLISHED = 'PUBLISHED';